module.exports = __webpack_public_path__ + "static/media/L0-JavaScript.48187a33.svg";